import { Skeleton } from "@mui/material"
import { FaMapPin } from "react-icons/fa6";
import { TiWeatherSunny } from "react-icons/ti";
import { TiWeatherDownpour } from "react-icons/ti";
import { TiWeatherWindyCloudy } from "react-icons/ti";
import { TiWeatherSnow } from "react-icons/ti";


import moment from "moment";
const Weather = ({ data, loading, searched }) => {
    const day = moment().format('dddd')
    const date = moment().format('DD MMMM')

    return (
        <div className="">
            <div className="w-full pt-5">

                {data ?
                    (<div className="grid place-content-end ">
                        <div className="text-xl font-bold">{day}</div>
                        <div className="text-xl tracking-wide">{date}</div>
                    </div>)
                    : null}


                {loading ? (
                    <div className="mt-10">
                        <Skeleton variant="text" autowidth="true" height={10} />
                    </div>
                ) : data ? (
                    <div className="bg-black h-[3px] my-10"></div>
                ) : searched ? null : null}


                <div className="py-10">
                    <div className="font-bold">
                        {loading ? (
                            <Skeleton variant="text" width={70} />
                        ) : data ? (
                            <div className="flex">
                                <div className="grid place-content-center pr-1">
                                    <FaMapPin className="text-sm" />
                                </div>
                                <div>{data?.data?.name}</div>
                            </div>
                        ) : searched ? (
                            <div className="grid place-content-center py-10">
                                <div className="text-center">Location not found</div>
                                <div className="text-sm font-thin text-center">Please try another location</div>

                            </div>
                        ) : (
                            <div className="grid place-content-center py-10 pt-24 gap-2">
                                <div className="text-xl font-normal">Welcome to <b className="font-black">Just Weather.</b></div>
                                <div className="text-lg font-thin text-center">literally just weather</div>
                                <div className="flex justify-center text-4xl gap-2 pt-3">
                                    <TiWeatherSunny />
                                    <TiWeatherDownpour />
                                    <TiWeatherWindyCloudy />
                                    <TiWeatherSnow />
                                </div>
                            </div>
                        )}
                    </div>
                    <div>
                        <div className=" text-7xl w-[190px] font-black pb-1">
                            {loading ? (
                                <Skeleton variant="text" width={100} />
                            ) :
                                (
                                    data ? data?.data?.main.temp.toFixed() + "°C" :
                                        null
                                )
                            }
                        </div>
                        <div className="">
                            {loading ? (
                                <Skeleton variant="text" width={120} />
                            ) :
                                (
                                    data ? "Feels like " + data?.data?.main.feels_like.toFixed() + "°C right now." :
                                        null
                                )
                            }
                        </div>
                    </div>
                </div>

                {loading ? (
                    <div className="mb-10">
                        <Skeleton variant="text" autowidth="true" height={10} />
                    </div>
                ) : data ? (
                    <div className="bg-black h-[3px] my-10"></div>
                ) : searched ? null : null}

                <div className="flex justify-between font-light text-lg">
                    <div className="">
                        <div className="gap-5">
                            <div className="font-bold">
                                {loading ? (
                                    <Skeleton variant="text" width={100} />
                                ) :
                                    (
                                        data ? "H " + data?.data?.main.temp_max.toFixed() + "°C" :
                                            null
                                    )
                                }
                            </div>
                            <div>
                                {loading ? (
                                    <Skeleton variant="text" width={100} />
                                ) :
                                    (
                                        data ? "L " + data?.data?.main.temp_min.toFixed() + "°C" :
                                            null
                                    )
                                }
                            </div>
                        </div>
                        <div>
                            <div>
                                <div className="text-xl">
                                    {loading ? (
                                        <Skeleton variant="text" width={80} />
                                    ) :
                                        (
                                            data ? data?.data?.weather[0]?.description :
                                                null
                                        )
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="">
                        {loading ? (
                            <Skeleton variant="circular" width={70} height={70} />
                        ) :
                            (
                                data ? (
                                    <div className="">
                                        <div className="grid place-content-center">
                                            <img src={`https://openweathermap.org/img/wn/${data?.data?.weather[0]?.icon}@2x.png`} alt="" className="w-[80px] rounded-full" />
                                        </div>
                                    </div>
                                ) : (
                                    null)
                            )
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}


export default Weather